import React from "react";
import { Post } from "../types/post";
import { useTable } from "react-table";

const PostTable: React.FC<{
  posts: Post[];
  onEditPost: (post: Post) => void;
  onDeletePost: (postId: string) => void;
}> = ({ posts, onEditPost, onDeletePost }) => {
  const columns = React.useMemo(
    () => [
      {
        Header: "Title",
        accessor: "title" as keyof Post,
      },
      {
        Header: "Author",
        accessor: "author" as keyof Post,
      },
      {
        Header: "Actions",
        Cell: ({ row }: { row: any }) => (
          <>
            <button
              className="bg-blue-500 text-white py-1 px-2 rounded-md hover:bg-blue-600 mr-2"
              onClick={() => onEditPost(row.original)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 text-white py-1 px-2 rounded-md hover:bg-red-600"
              onClick={() => onDeletePost(row.original.id)}
            >
              Delete
            </button>
          </>
        ),
      },
    ],
    [onEditPost, onDeletePost]
  );

  const tableInstance = useTable({ columns, data: posts });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  return (
    <table {...getTableProps()} className="w-full border border-black">
      <thead className="border border-black">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()} className="px-4 py-2">
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <td
                  {...cell.getCellProps()}
                  className="border border-black px-4 py-2"
                >
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default PostTable;
